import { render, staticRenderFns } from "./DramaManagement.vue?vue&type=template&id=28ae4d78&scoped=true"
import script from "./DramaManagement.vue?vue&type=script&lang=js"
export * from "./DramaManagement.vue?vue&type=script&lang=js"
import style0 from "./DramaManagement.vue?vue&type=style&index=0&id=28ae4d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae4d78",
  null
  
)

export default component.exports